module.exports = __webpack_public_path__ + "static/img/asfc.f8fc110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/asfc.png
// module id = lTCy
// module chunks = 1